export * from './components/Label/index';
//# sourceMappingURL=Label.js.map